import React, { useMemo } from "react"
import { Link } from "gatsby"
import cx from "classnames"
import PropTypes from "prop-types"
import { useLocation } from "@reach/router"
import upperFirst from "lodash/upperFirst"
import isEmpty from "lodash/isEmpty"

import { useTranslation } from "../../helpers/useTranslation"

import BlogSearch from "../blogSearch"

import * as styles from "./categories.module.scss"

const Categories = props => {
  const { t } = useTranslation()
  const location = useLocation()
  const { blogSearchKeys, categories, sidebar, link, onSearchKeySelect, selectPlaceholder } = props

  const isAllActive = location.pathname === `/${link}` || location.pathname.includes(`/${link}/page`)

  const blogSearchOptions = useMemo(
    () => blogSearchKeys.map(item => ({ label: item.key, value: item.key.replace(/\s+/g, "").toLowerCase() })),
    [blogSearchKeys]
  )

  return (
    <div
      className={cx(styles.categoriesBlock, {
        [styles.hasSearchBar]: !isEmpty(blogSearchOptions),
      })}>
      <ul
        className={cx(styles.wrapper, {
          [styles.sidebar]: !!sidebar,
          [styles.overflow]: isEmpty(blogSearchOptions),
        })}>
        <li className={styles.item}>
          <Link to={`/${link}`} partiallyActive={isAllActive} activeClassName={styles.active}>
            {upperFirst(t("all"))}
          </Link>
        </li>
        {categories.nodes.map((cat, id) => (
          <li key={id} className={cx(styles.item, cat.divider && styles.withDivider)}>
            <Link to={`/${link}/${cat.slug.current}`} partiallyActive activeClassName={styles.active}>
              {cat.title}
            </Link>
          </li>
        ))}
      </ul>
      {!isEmpty(blogSearchOptions) && (
        <BlogSearch
          classNamePrefix="blog-search"
          selectSearchKey={onSearchKeySelect}
          options={blogSearchOptions}
          placeholder={selectPlaceholder}
        />
      )}
    </div>
  )
}

Categories.propTypes = {
  blogSearchKeys: PropTypes.array,
  categories: PropTypes.object.isRequired,
  sidebar: PropTypes.bool,
  market: PropTypes.string,
  onSearchKeySelect: PropTypes.func,
}

Categories.defaultProps = {
  blogSearchKeys: [],
  categories: {},
  sidebar: false,
  market: "",
}

export default Categories
